import $ from 'jquery'

let filters = [];
let filter_values = [];
let filter_params = [];

function initResults() {

    setListeners()
}

function do_filters() {
    let url = new URL(window.location.origin + window.location.pathname);


    let param_str = '';
    for (const [key, value] of Object.entries(filter_values)) {
        param_str = ''
        if (value instanceof Array) {
            let c = false
            for (const [subkey, subvalue] of Object.entries(value)) {
                if (c) {
                    param_str += ','
                }
                c = true
                param_str += subvalue

            }
        } else {
            param_str += value
        }

        if (param_str) {
            // if (k){
            //     //console.log(value)
            // }

            // const k = key.replace('_', '')
            url.searchParams.set(key, param_str);
        }
    }

    document.location = url

}

function setListeners() {
    $('.publisher-results__sorting_button--search').on('click', function (event) {

        get_filter_values();


        filterResults();
    });
}

function get_filter_values() {
    filters = $('.publisher-results__filter');
    let filter = [];

    for (let i = 0, len = filters.length; i < len; i++) {
        filter = filters[i];
        get_filter_value(filter)
    }

    do_filters();

}


function get_filter_value(obj) {

    let filter_selector = '';
    let results = [];
    let id = $(obj).data('filter-id');
    let type = $(obj).data('filter-type');

    switch (type) {
        case 'checkbox':

            filter_selector = '*[name*="' + id + '"]:checked';
            results = $(obj).find(filter_selector);
            filter_values[id] = []

            for (let r = 0, rlen = results.length; r < rlen; r++) {
                const result = $(results[r]).val()
                filter_values[id].push(result)

            }

            break;

        case 'select':

//             filter_selector = '*[name*="' + id + '"] *:selected';
//             results = $(obj).find(filter_selector);
//             filter_values[id] = []
//
//             for (let r = 0, rlen = results.length; r < rlen; r++) {
//                 const result = $(results[r]).val()
//                 // filter_values[id].push(result)
// // //console.log( filter_values[id]);
//                 //console.log(result)
//             }

            //
            $(obj).each(function () {
                if ($(this).val() !== 'all') {
                    filter_values[id] = $(this).val()
                }
            });
            break;
    }
}

function filterResults() {
    //console.log('filterResults')

}


//
export default initResults;


